import * as t from "../VideoTourClockService/actionTypes";

const initialState = {
	ticks: null,
	instances: []
};

const videoTourClock = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case t.VIDEO_TOUR_INSTANCE_ADDED: {
			return { ...state, instances: [...state.instances, payload.instanceId] };
		}
		case t.VIDEO_TOUR_INSTANCE_REMOVED: {
			const newInstanceIds = [...state.instances];
			const index = newInstanceIds.indexOf(payload.instanceId);
			newInstanceIds.splice(index, 1);
			return { ...state, instances: newInstanceIds };
		}
		case t.SET_VIDEO_TOUR_CLOCK_TICKS: {
			return { ...state, ticks: payload.ticks };
		}
		default:
			return state;
	}
};

export default videoTourClock;
